module.exports = __webpack_public_path__ + "img/Entia-Generacion-de-energia-medio-ambiente-5.dbb46b82.webp";